import { Button, Modal } from "antd";
import { SRSApplicantType } from "utils/Types";
import { useTranslation, Trans } from "react-i18next";
import styles from "./style.module.scss";
import { formatName } from "utils/Format";

type FlagModalType = {
  student: SRSApplicantType;
  isOpen: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onSubmit: (refNum: number) => void;
};

const FlagModal = ({ student, isOpen, isSubmitting, onClose, onSubmit }: FlagModalType) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t("srsApplications.flag.modal.title")}
      open={isOpen}
      closable={!isSubmitting}
      onCancel={onClose}
      maskClosable={false}
      footer={[
        <Button key="cancel" disabled={isSubmitting} style={{ marginRight: 8 }} onClick={onClose}>
          {t("srsApplications.flag.modal.cancelBtn")}
        </Button>,
        <Button
          key="flag a student"
          className={styles["flag-btn"]}
          type="primary"
          loading={isSubmitting}
          onClick={() => onSubmit(student?.refNum)}
        >
          {t("srsApplications.flag.modal.flagBtn")}
        </Button>
      ]}
    >
      <Trans>
        {t("srsApplications.flag.modal.body1")}
        <ul>
          <li className={styles["student-info-label"]}>
            {t("srsApplications.flag.modal.numberLabel")} {student?.studentNumber}
          </li>
          <li className={styles["student-info-label"]}>
            {t("srsApplications.flag.modal.nameLabel")} {`${formatName(student.fullName)}`}
          </li>
          <li className={styles["student-info-label"]}>
            {t("srsApplications.flag.modal.schoolLabel")} {student.schoolName}
          </li>
        </ul>
        {t("srsApplications.flag.modal.body2")}
      </Trans>
    </Modal>
  );
};

export default FlagModal;
